import styled, { css } from 'styled-components';

import { FONT_TYPES, fontFamilyMixin, mediaMixin, Text, typographyMixin } from '@zillow/constellation';

import type { TypographyMixinProps } from '@zillow/constellation';

const getStyleH3 = (props: typeof TypographyMixinProps) => css`
  ${typographyMixin({ ...props, fontType: FONT_TYPES.h5 })}

  /* 481 (tablet) */
    ${mediaMixin(
    'md',
    css`
      ${typographyMixin({ ...props, fontType: FONT_TYPES.h4 })};
    `,
  )}

    /* 1024 (desktop) */
    ${mediaMixin(
    'xl',
    css`
      ${typographyMixin({ ...props, fontType: FONT_TYPES.h3 })};
    `,
  )}

    /* override font family last */
    ${mediaMixin(
    'xs',
    css`
      ${fontFamilyMixin({ ...props, fontFamily: 'serif' })}
    `,
  )}
`;

const getStyleH4 = (props: typeof TypographyMixinProps) => css`
  ${typographyMixin({ ...props, fontType: FONT_TYPES.h6 })}

  /* 481 (tablet) */
    ${mediaMixin(
    'md',
    css`
      ${typographyMixin({ ...props, fontType: FONT_TYPES.h5 })};
    `,
  )}

    /* 1024 (desktop) */
    ${mediaMixin(
    'xl',
    css`
      ${typographyMixin({ ...props, fontType: FONT_TYPES.h4 })};
    `,
  )}

    /* override font family last */
    ${mediaMixin(
    'xs',
    css`
      ${fontFamilyMixin({ ...props, fontFamily: 'serif' })}
    `,
  )}
`;

const getStyleBody = (props: typeof TypographyMixinProps) => css`
  ${typographyMixin({ ...props, fontType: FONT_TYPES.body })}
`;

const getStyle = (props: typeof TypographyMixinProps) => {
  switch (props.fontType) {
    case FONT_TYPES.h3:
      return css`
        ${getStyleH3}
      `;
    case FONT_TYPES.h4:
      return css`
        ${getStyleH4}
      `;
    case FONT_TYPES.body:
      return css`
        ${getStyleBody}
      `;
    default:
      return null;
  }
};

const StyledResponsiveText = styled(Text)`
  ${getStyle}
`;

export default StyledResponsiveText;
